import { render, staticRenderFns } from "./SuccessPage.vue?vue&type=template&id=2165b5c2&scoped=true&"
import script from "./SuccessPage.vue?vue&type=script&lang=js&"
export * from "./SuccessPage.vue?vue&type=script&lang=js&"
import style0 from "./SuccessPage.vue?vue&type=style&index=0&id=2165b5c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2165b5c2",
  null
  
)

export default component.exports